import { Box, Button, Checkbox, FormControlLabel } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createSearchParams, useNavigate, useParams } from 'react-router-dom';

import DialogCustom from 'commons/DialogCustom';
import TermsDialog from 'commons/TermsDialogy';
import Text from 'commons/Text';
import useRequestCertificate from 'hooks/useSendCertificateRequest';
import useUploadImageS3 from 'hooks/useUploadImageS3';
import GridLayout from 'layouts/GridLayout';
import Routes from 'utils/Route';
import { ToastTopHelper } from 'utils/utils';

import MainContentWrapper from '../MainContentWrapper';
import useStyles from './styles';

const UpdateInfoStep = ({
  artwork,
  artworkFormState,
  listUploadedImages,
  setListUploadedImages,
  requestUser,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const navigate = useNavigate();
  const { artworkId } = useParams();

  const [isShowDialog, setIsShowDialog] = useState(false);
  const [openTerms, setOpenTerms] = useState(false);
  const [agree, setAgree] = useState(false);

  const { handleSubmit, watch } = artworkFormState;
  const data = watch();
  const { mutate: requestCertificate } = useRequestCertificate(artworkId);
  const { uploadListImage } = useUploadImageS3();

  const handleCancel = () => {
    setIsShowDialog(true);
  };

  const handleCancelDialog = () => {
    setIsShowDialog(false);
  };

  const handleSubmitlDialog = () => {
    setIsShowDialog(false);
    navigate(-1);
  };

  const createCertificateRequest = async () => {
    let imagesKey = listUploadedImages.map((image) => image?.imageKey);

    if (!data?.selectedUser?.id) {
      return;
    }

    const formData = {
      artwork: {
        uuid: artworkId,
        title: data?.titleArtwork,
        size: {
          height: data?.height,
          width: data?.width,
          depth: data?.depth,
        },
        period_year: data?.periodYear,
        year_created: data?.yearCreated,
        total_edition: data?.editionVolume,
        medium: data?.mediumArtWork,
        artist_artwork: data?.artistArtwork,
        tag_request: {
          request_by: data?.tagRequest?.request_by?.id,
          request_to: data?.tagRequest?.request_to?.id,
        },
        piece: data?.piece,
      },
      edition: data?.edition,
      owner_info: {
        name: data?.ownerName,
        year_of_birth: data?.yearOfBirth,
        address: data?.ownerAddress,
      },
      request_to: data?.selectedUser?.id,
      images: imagesKey,
    };

    requestCertificate(formData, {
      onSuccess: () => {
        ToastTopHelper.success(t('request_certificate_success'));
        navigate({
          pathname: Routes.ManageCertificate,
          search: createSearchParams({ tab: 1 }).toString(),
        });
      },
    });
  };

  const handleUpdateArtwork = async () => {
    const uploadS3Response = await uploadListImage(listUploadedImages);
    const allSuccessful = uploadS3Response.every((response) => response?.success === true);

    if (allSuccessful) {
      createCertificateRequest();
    }
  };

  return (
    <Box sx={{ pt: 3 }}>
      <GridLayout>
        <MainContentWrapper
          artworkFormState={artworkFormState}
          artwork={artwork}
          listUploadedImages={listUploadedImages}
          setListUploadedImages={setListUploadedImages}
          requestUser={requestUser}
        />

        <div className={classes.wrapBoxSendCer}>
          <FormControlLabel
            control={
              <Checkbox
                checked={agree}
                onChange={(e) => setAgree(e.target.checked)}
                color="primary"
              />
            }
            label={
              <Text variant="span">
                {t('i_have_read_and_agree_to')}{' '}
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenTerms(true);
                  }}
                  href="/terms-and-conditions"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'underline', fontWeight: 500 }}
                >
                  {t('gladius_art_terms_conditions')}
                </a>
                .
              </Text>
            }
            className={classes.checkboxAgreement}
          />

          <Button
            variant="contained"
            fullWidth
            className={classes.button}
            onClick={handleSubmit(handleUpdateArtwork)}
            disabled={!agree}
          >
            {t('send_request')}
          </Button>

          <Button
            variant="outlined"
            fullWidth
            className={classes.buttonCancel}
            onClick={handleCancel}
          >
            {t('cancel')}
          </Button>
        </div>
      </GridLayout>

      <DialogCustom
        isShowDialog={isShowDialog}
        dialogTitle={t('cancel_request')}
        textCancel={t('continue')}
        textSubmit={t('yes_canccel')}
        onCancel={handleCancelDialog}
        onSubmit={handleSubmitlDialog}
        maxWidth={'md'}
      >
        <div>{t('are_you_sure_exit_certificate')}</div>
      </DialogCustom>

      <TermsDialog
        open={openTerms}
        onClose={() => setOpenTerms(false)}
      />
    </Box>
  );
};

export default UpdateInfoStep;
